import { render } from "./Sede.vue?vue&type=template&id=4aa96b53&scoped=true"
import script from "./Sede.vue?vue&type=script&lang=js"
export * from "./Sede.vue?vue&type=script&lang=js"

import "./Sede.vue?vue&type=style&index=0&id=4aa96b53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa96b53"]])

export default __exports__